"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkClaims = checkClaims;
function checkClaims(claims, requiredClaims) {
  if (!requiredClaims) {
    return true;
  }
  if (!claims) {
    return false;
  }
  for (var key in requiredClaims) {
    var parts = key.split(".");
    var obj = claims;
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      var newObj = obj[part];
      if (!newObj) {
        return false;
      }
      if (i === parts.length - 1) {
        return newObj === requiredClaims[key];
      }
      obj = newObj;
    }
  }
  return false;
}


//////////////////
// WEBPACK FOOTER
// ./~/gocommerce-js/lib/claims.js
// module id = 372
// module chunks = 231608221292675